/**
 * Redirects legacy invitation links to the canonical SPA route.
 *
 * Historical email templates used:
 *   /invitations/accept?token=<raw>
 * Canonical route:
 *   /invite/<raw>
 */
import { Navigate, useSearchParams } from "react-router-dom";

export function LegacyInviteRedirect() {
	const [params] = useSearchParams();
	const token = params.get("token")?.trim();
	if (token && token.length > 0) {
		return <Navigate to={`/invite/${encodeURIComponent(token)}`} replace />;
	}
	return <Navigate to="/dashboard" replace />;
}
